<cc-box>
  <div content box>
    <div class="numbers-header" translate>
      ORDER_NUMBER.{{ isFullyConfigured ? 'CHOOSE_DIFFERENT_NUMBER' : 'CHOOSE_FIRST_NUMBER'}}
    </div>
    <div class="numbers-description" translate>
      ORDER_NUMBER.{{isFullyConfigured ? 'SELECT_COUNTRY_DESCRIPTION' : 'CHOOSE_FIRST_NUMBER_DESCRIPTION' }}
    </div>

    <form [formGroup]="filtersForm" class="filters">
      <div class="select-filters">
        <div class="select-filter">
          <div class="label-filter" translate>PLANS.COUNTRY</div>
          <cc-countries-dropdown
            [initialCountryCode]="initialNumberCode"
            [isFullyConfigured]="isFullyConfigured"
            (change)="changeCountry($event)"
          >
          </cc-countries-dropdown>
        </div>

        <div class="select-filter">
          <div class="label-filter" translate>ORDER_NUMBER.NUMBER_TYPE</div>
          <cc-number-types-dropdown
            [form]="filtersForm"
            controlName="type">
          </cc-number-types-dropdown>
        </div>

        <div class="select-filter" *ngIf="regions.length && !isTollFree">
          <div class="label-filter" translate>ORDER_NUMBER.STATE_PROVINCE</div>
          <cc-regions-dropdown
            [form]="filtersForm"
            controlName="region"
            [regions]="regions">
          </cc-regions-dropdown>
        </div>
      </div>

      <cc-search-input
        [form]="filtersForm"
        controlName="search"
        placeholder="{{ 'ORDER_NUMBER.SEARCH_PLACEHOLDER'| translate}}">
      </cc-search-input>
    </form>

    <cc-pricing-numbers-table
      [filters]="filtersForm.getRawValue()"
      [isFullyConfigured]="isFullyConfigured">
    </cc-pricing-numbers-table>
  </div>
</cc-box>
